import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "src/app/services/app-config.service";
import { PMAPIServiceConstant } from "../constants/pm-service.constant";
import { Observable } from "rxjs";
import { PMBuild } from "../models/pm-build.model";

@Injectable({
    providedIn: 'root'
})
export class PMService {
    httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    };

    apiUrl = AppConfig.settings.apiUrl;

    constructor(private http: HttpClient) { }

    getPMDataByCrId(crNo: any): Observable<PMBuild[]> {
        return this.http.get<PMBuild[]>(`${this.apiUrl}${PMAPIServiceConstant.GETPMBUILD}?crid=${crNo}`, this.httpOptions);
    }

    createPMBuild(crNo: any) {
        return this.http.post(`${this.apiUrl}${PMAPIServiceConstant.CREATEPMBUILD}?crid=${crNo}`, {}, this.httpOptions);
    }

    addNewPM(crNo: any) {
        return this.http.post(`${this.apiUrl}${PMAPIServiceConstant.ADDNEWPM}?crid=${crNo}`, {}, this.httpOptions);
    }

    copyPMBuild(crNo: any, data: any) {
        return this.http.post(`${this.apiUrl}${PMAPIServiceConstant.COPYPMBUILD}?crid=${crNo}`, data, this.httpOptions);
    }

    updatePMBuild(crNo: any, data: any) {
        return this.http.post(`${this.apiUrl}${PMAPIServiceConstant.UPDATEPMBUILD}?crid=${crNo}`, data, this.httpOptions);
    }

    deletePMBuild(data: any) {
        return this.http.post(`${this.apiUrl}${PMAPIServiceConstant.DELETEPMBUILD}`, data, this.httpOptions);
    }

    getPmSearch(data: any) {
        return this.http.post(`${this.apiUrl}${PMAPIServiceConstant.GETPMSearch}`, data, this.httpOptions);
    }

  getRouteTag(skip: number, pageSize: number = 5, searchText: string, fetchAllRecords = false) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }
        if (fetchAllRecords) {
          params.push(`fetchAllRecords=${fetchAllRecords}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}${PMAPIServiceConstant.GETROUTETAG}${url}`, this.httpOptions);
    }

    getFreqIndicator(skip: number, pageSize: number = 5, searchText: string) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}${PMAPIServiceConstant.GETFREQINDICATOR}${url}`, this.httpOptions);
    }

    getMwoData(skip: number, pageSize: number = 5, searchText: string, crNo: number) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}&crId=${crNo}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }
        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}${PMAPIServiceConstant.GETMWODATA}${url}`, this.httpOptions);
    }

    getMwoValid(searchText: string, crNo: number){
        let params = [];
        params.push(`searchText=${searchText}&crId=${crNo}`);
        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}${PMAPIServiceConstant.GETVALIDMWO}${url}`, this.httpOptions);

    }

    getMinorServiceTypes(skip: number, pageSize: number = 5, searchText: string,equipTag : string,serviceType : string) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}&equipTag=${equipTag}&serviceType=${serviceType}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}${PMAPIServiceConstant.GETMINORSERVICETYPE}${url}`, this.httpOptions);
    }

    getServiceType(skip: number, pageSize: number = 5, searchText: string) {
        let params = [];
        if (pageSize > 0) {
            params.push(`skip=${skip}&pageSize=${pageSize}`);
        }
        if (searchText) {
            params.push(`searchText=${searchText}`);
        }

        let url = params.length > 0 ? `?${params.join('&')}` : "";
        return this.http.get(`${this.apiUrl}${PMAPIServiceConstant.GETSERVICETYPE}${url}`, this.httpOptions);
    }

    addAssociationRow(crNo: number, payload: any) {
        let url = `?crid=${crNo}`;
        return this.http.post(`${this.apiUrl}${PMAPIServiceConstant.ADDASSOCIATIONS}${url}`, payload, this.httpOptions);
    }

    deleteEquipmentRouteAssociation(payload: any) {
        return this.http.post(`${this.apiUrl}${PMAPIServiceConstant.DELETEEQUIPMENTROUTEASSOCIATION}`, payload, this.httpOptions);
    }

    savePMBuild(crId: number, payload: any) {
        return this.http.put(`${this.apiUrl}${PMAPIServiceConstant.SAVEPMBUILD}?crid=${crId}`, payload, this.httpOptions);
    }

    validatePMBuild(crId: number, payload: any) {
        return this.http.post(`${this.apiUrl}${PMAPIServiceConstant.VALIDATEPMBUILD}?crid=${crId}`, payload, this.httpOptions);
    }

    checkMwoNumberExists(crId: number, payload: any[],isSearch:boolean =false) {
        return this.http.post(`${this.apiUrl}${PMAPIServiceConstant.VALIDATEMWONUMBERONSAVE}?crid=${crId}&isSearch=${isSearch}`, payload, this.httpOptions);
    }

    importPMHeader_EquipmentRoute(crNo: number, payload: any, isHeaderImport: boolean) {
        let url = `?crid=${crNo}`;
        return this.http.post(`${this.apiUrl}${isHeaderImport ? PMAPIServiceConstant.IMPORTPMHEADER : PMAPIServiceConstant.IMPORTPMROUTE}${url}`, payload, this.httpOptions);
    }
}
